import data from './data'
import methods from './methods'
import mounted from './mounted'

export default {
  data,
  methods,
  mounted,

  /* route API for professional address */
  resourcePath: 'v1/professional/companies/staffs'
}



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/resources/index.js